import type { CoachingSession } from '@efdigital/ll-addon-data';
import type AdminSessionsService from '@efdigital/ll-admin-v2/services/admin-sessions';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { AdminActionModal } from './admin-action-modal.gts';

interface SessionClearExternalReviewModalSignature {
  Args: {
    coachingSession: CoachingSession;
    onSuccess?: () => Promise<void>;
  };
  Blocks: {
    clearExternalReview: [showModal: () => void];
  };
}

export class SessionClearExternalReviewModal extends Component<SessionClearExternalReviewModalSignature> {
  @service declare adminSessions: AdminSessionsService;

  clearExternalReview = async () => {
    await this.adminSessions.clearExternalReview(this.args.coachingSession.id!);
    await this.args.onSuccess?.();
  };

  <template>
    <AdminActionModal
      @title="Mark as still scheduled"
      @submitLabel="Mark as still scheduled"
      @submittingLabel="Restoring…"
      @submitButtonClass="btn-primary"
      @initialValue={{true}}
      @onSubmit={{this.clearExternalReview}}
    >
      <:trigger as |showModal|>
        {{yield showModal to="clearExternalReview"}}
      </:trigger>
      <:description>
        An external calendar change was detected on the coach's Cronofy event
        for this session — it may have been moved or deleted outside the
        platform. Use this once you've confirmed directly with the coach (or by
        checking their calendar) that
        <strong>the originally agreed time still stands</strong>. This dismisses
        the flag and restores the session to
        <code>scheduled</code>
        — it does not change the session's time. If the coach actually moved it,
        cancel and rebook instead.
      </:description>
      <:fields></:fields>
    </AdminActionModal>
  </template>
}
